module.exports = __webpack_public_path__ + "img/feven_horizontal_white.5a30797d.svg";